import React from 'react';
import { motion } from 'framer-motion';
import './RegistrationSection.css';

const RegistrationSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const handleRegisterClick = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSegzW7rEhr_P08wdtvehbhdKQCeo25YwA0o4x9yzaYiUUDGjw/viewform?usp=header', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="registration" className="registration-section">
      <div className="registration-background">
        <div className="registration-pattern"></div>
      </div>
      
      <div className="container">
        <motion.div 
          className="registration-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="registration-header" variants={itemVariants}>
            <div className="section-icon">
              <span className="icon">🎯</span>
            </div>
            <h2 className="section-title">التسجيل مغلق - قائمة الانتظار مفتوحة!</h2>
            <p className="section-subtitle">
              تم ملء جميع الأماكن! انضم إلى قائمة الانتظار لتحصل على إشعار فوري في حالة توفر مكان
            </p>
            
            <motion.div 
              className="no-coding-chip"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              <span className="chip-icon">🤯</span>
              <span className="chip-text">لا تحتاج معرفة برمجية للفوز!</span>
            </motion.div>
          </motion.div>

          <motion.div className="registration-info" variants={itemVariants}>
            <div className="info-grid">
              <div className="info-card">
                <div className="card-icon">🚀</div>
                <h3>تحدي الابتكار</h3>
                <p>شارك في تحدٍ تقني مكثف لمدة يوم واحد</p>
              </div>
              
              <div className="info-card">
                <div className="card-icon">🏆</div>
                <h3>جوائز قيمة</h3>
                <p>تنافس على جوائز مالية وعينية رائعة</p>
              </div>
              
              <div className="info-card">
                <div className="card-icon">🤝</div>
                <h3>شبكة مهنية</h3>
                <p>تعرف على مطورين ومهندسين موهوبين</p>
              </div>
              
            </div>
          </motion.div>

          <motion.div className="registration-cta" variants={itemVariants}>
            <div className="cta-content">
              <h3>انضم إلى قائمة الانتظار!</h3>
              <p>
                جميع الأماكن محجوزة! انضم إلى قائمة الانتظار وسنخبرك فوراً 
                في حالة توفر أي مكان أو إلغاء أي تسجيل.
              </p>
              
              <div className="registration-steps">
                <div className="step">
                  <span className="step-number">1</span>
                  <span className="step-text">املأ النموذج للانضمام إلى قائمة الانتظار</span>
                </div>
                <div className="step">
                  <span className="step-number">2</span>
                  <span className="step-text">تأكد من صحة المعلومات المدخلة</span>
                </div>
                <div className="step">
                  <span className="step-number">3</span>
                  <span className="step-text">انتظر إشعار فوري عند توفر مكان</span>
                </div>
              </div>
              
              {/* Retro Loading Bar */}
              <motion.div 
                className="retro-loading-container"
                variants={itemVariants}
              >
                <div className="loading-bar-wrapper">
                  <div className="loading-bar-label">
                    <span className="loading-text">جميع الأماكن محجوزة</span>
                  </div>
                  <div className="retro-loading-bar">
                    <div className="loading-bar-fill" style={{width: '100%'}}></div>
                    <div className="loading-bar-dots">
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                    </div>
                  </div>
                  <div className="loading-bar-message">
                    <span className="urgent-text">⏰ انضم إلى قائمة الانتظار - قد تتاح أماكن قريباً!</span>
                  </div>
                </div>
              </motion.div>
            </div>
            
            <motion.button 
              className="btn-primary registration-btn"
              onClick={handleRegisterClick}
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 8px 25px rgba(0, 123, 255, 0.3)"
              }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              <span className="btn-emoji">⏳</span>
              انضم إلى قائمة الانتظار
              <span className="btn-arrow">→</span>
            </motion.button>

            <div className="calendar-reminder-text">
              <p>لا تنس إضافة الحدث إلى التقويم ونراك قريباً</p>
            </div>
            
            <motion.button 
              className="btn-calendar-large"
              onClick={(e) => {
                e.preventDefault();
                console.log('Calendar button clicked!'); // Debug log
                
                try {
                  // Create calendar event data
                  const startDate = new Date('2025-10-11T08:00:00');
                  const endDate = new Date('2025-10-11T18:00:00');
                  const title = 'هاكاثون الطيرة 2025';
                  const description = 'انضم إلينا في رحلة الابتكار والتطوير التقني';
                  const location = 'TIRA';
                  
                  // Create .ics file content
                  const formatDate = (date) => {
                    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
                  };
                  
                  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//TIRA Hackathon//Event//EN
BEGIN:VEVENT
UID:${Date.now()}@tirahackathon.com
DTSTAMP:${formatDate(new Date())}
DTSTART:${formatDate(startDate)}
DTEND:${formatDate(endDate)}
SUMMARY:${title}
DESCRIPTION:${description}
LOCATION:${location}
STATUS:CONFIRMED
SEQUENCE:0
END:VEVENT
END:VCALENDAR`;
                  
                  console.log('Creating ICS file...'); // Debug log
                  
                  // Create and download .ics file
                  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
                  const link = document.createElement('a');
                  link.href = URL.createObjectURL(blob);
                  link.download = 'TIRA-Hackathon-2025.ics';
                  link.style.display = 'none';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(link.href);
                  
                  console.log('ICS file download initiated'); // Debug log
                } catch (error) {
                  console.error('Error creating calendar event:', error);
                  alert('حدث خطأ في إضافة الحدث إلى التقويم. يرجى المحاولة مرة أخرى.');
                }
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="button"
            >
              <span className="btn-icon-large">📅</span>
              <span className="btn-text-large">أضف إلى التقويم</span>
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default RegistrationSection;
